import AppScrollbar from "_lib/AppScrollbar";
import { Flex } from "antd";
import styled from "styled-components";

export const StyledAppSidebarScrollbar = styled(AppScrollbar)`
  /* height: calc(100vh - 385px); */
  height: calc(100vh - 182px);
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    /* height: calc(100svh - 362px); */
    height: calc(100svh - 182px);
  }
`;
export const StyledAppSidebarScrollbarContent = styled(Flex)`
  height: 100%;
  padding: 24px;
  svg {
    cursor: pointer;
  }
`;

export const StyledAppSideBarFooter = styled(Flex)`
  width: 100%;
  .app-sidebar-footer-container {
    width: 100%;
  }
  svg {
    cursor: pointer;
    fill: ${({ theme }) => theme.palette.text.primary};
  }
`;

export const StyledAppSidebarFooterInfo = styled(Flex)`
  max-width: 140px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    max-width: none;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xxs}px) {
    max-width: 140px;
  }
`;
